
export type IPurchaseReturn = {
  _id: string;
  purchaseOrderId: string,
  purchaseOrderDescription: string,
  createdAt: Date;
  updatedAt: Date;
  returnRequestor: string;
  reason: string;
  products: IPurchaseReturnProducts[];
}

export type IPurchaseReturnProducts = {
  description: string,
  qtd: number,
  value: string,
  productId: string
}

export const emptyPurchaseReturn = (): IPurchaseReturn => ({
  _id: "",
  purchaseOrderId: '',
  purchaseOrderDescription: '',
  createdAt: new Date(),
  updatedAt: new Date(),
  returnRequestor: "",
  products: [],
  reason: ""
});
